import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'


import CourseChapterInfo from 'components/molecules/CourseChapterInfo'

import { useGET_courseByIdQuery, useGET_courseChaptersQuery } from 'redux/api/coursesApi'
import { FaFileDownload } from 'react-icons/fa'

interface IProps {
  id: number
  course_chapter_id?: number
  tabText?: string
  tabKey?: string
}

const slideProps = {
  mountOnEnter: true,
  unmountOnExit: true,
  timeout: { enter: 225, exit: 195 }
};

const CourseInfo: FC<IProps> = ({ id, course_chapter_id }) => {
  const { t } = useTranslation()

  const { data: course } = useGET_courseByIdQuery(id.toString())
  const { data: chapters } = useGET_courseChaptersQuery({page: 1, page_size: 100, course: id})

  return (
    <> { 
        course && chapters && 

        <Box sx={{ padding: 0 }}>
            <Typography>
                <span dangerouslySetInnerHTML={{ __html: course.description }} />
            </Typography>

          { /*
          <Accordion  
            TransitionProps={slideProps} 
            defaultExpanded
            key="description">
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography sx={{ fontSize: '1.4rem' }}>{`${t('common.course-description')}`}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <span dangerouslySetInnerHTML={{ __html: course.description }} />
              </Typography>
            </AccordionDetails>
          </Accordion>
    
         
            chapters.results.map(chapter => 
              <Accordion 
                TransitionProps={slideProps}
                key={chapter.id} 
                defaultExpanded={course_chapter_id === chapter.id}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography>
                  {chapter.sort_order}. {chapter.title}{chapter.materials_count > 0 && 
                      <span style={{ marginLeft: '20px' }}><FaFileDownload /> {`${chapter.materials_count} ${t('common.materials')}`}</span>}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>  
                  <Typography>
                    <CourseChapterInfo chapter={chapter}/>
                  </Typography>
                </AccordionDetails>
              </Accordion>  
            ) 
          */ }
        </Box>
        }
    </>
  )
}

export default CourseInfo
